import appInfo from '../app-info';
import { apiHelper, call_post_api } from './api_helper';
export const truongApi = {
    SelectByCoSo: (dm_coso_id) => apiHelper.get(`truong/coso/${dm_coso_id}`),
}
export async function dm_truong_select_by_coso(id) {
    return call_post_api(appInfo.api_url + '/truong/select_by_coso_id',id);
};